module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), (!_vm.scanComplete) ? _c('h3', {
    staticClass: "text-info"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n        Press Start Scanning and then use your scanner to scan the code on the right")]) : _c('div', [(_vm.scannerResults.invalidParse) ? _c('div', [_vm._m(1)]) : _c('div', [(_vm.scannerResults.requiresEnter) ? _c('h4', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n                    Scanner needs to be configured to have Line feed after scan. Please refer to scanner manual to configure.\n                ")]) : _c('h4', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa  fa-check"
  }), _vm._v("\n                    Scanner is correctly configured\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "150px",
      "width": "150px"
    },
    attrs: {
      "src": require("../../../Assets/barcode.gif")
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (!_vm.started) ? _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.start
    }
  }, [_vm._v("Start Scanning")]) : _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.stop
    }
  }, [_vm._v("Stop Scanning")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Configure Scanner")]), _vm._v(" "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n                Could not calibrate scanner! Contact Support.")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d080cd5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d080cd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/FmdControls/BagManagement/ScannerCalibration.scp.html
// module id = 534
// module chunks = 0